export default "__VITE_ASSET__DX3$pHeZ__"